import React, { useState, FormEvent, useEffect, useRef } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { POST } from "../../config/https";
import APIS from "../../config/api";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { usePersistentState } from "../../contexts/global-context";
import Color from "../../theme/color";
import { Button, Checkbox, Link, Typography } from "@mui/material";
import FullScreenLoader from "../full-screen-loader";
import { STRING } from "../../resources/string";
import {
  isEmpty,
  isValidEmail,
  isValidPhoneNumber,
} from "../../utils/validator";
import { stripePublishableKey } from "../../utils/constant";
import { GetLocalStorage } from "../../utils/local-storage";
type Options = {
  mode: "payment";
  amount: number;
  currency: string;
  appearance: any;
};

const CheckoutForm: React.FC = () => {
  const stripe = useStripe() as Stripe | null;
  const location: any = useLocation();
  const [state]: any = usePersistentState();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const checkOutData = GetLocalStorage("CheckOutData");
  const checkOutDataEventDetail = GetLocalStorage("CheckOutDataEventDetail");

  const [isAgree, setIsAgree] = useState(false);

  const [validation, setValidation] = useState(false);
  const [validatorError, setValidatorErrors] = useState<Record<string, string>>(
    {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
    }
  );

  useEffect(() => {
    if (validation) {
      formValidator();
    }
  }, [validation, state?.validatorError]);

  const formValidator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(checkOutData?.detail?.firstName)) {
      errors.firstName = "Please enter an first Name";
    }

    if (isEmpty(checkOutData?.detail?.lastName)) {
      errors.lastName = "Please enter an last Name";
    }
    if (isEmpty(checkOutData?.detail?.phone)) {
      errors.phone = "Please enter an phone";
    }

    if (isEmpty(checkOutData?.detail?.email)) {
      errors.email = "Please enter an email";
    } else if (!isValidEmail(checkOutData?.detail?.email)) {
      errors.email = "Please enter a valid email";
    } else {
      delete errors.email;
    }

    setValidatorErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const handlePublishOnClick = (e: any) => {
    e.preventDefault();
    if (isAgree) {
      handleSubmit(e);
    } else {
      toast.error("Please check i agree to the privacy and policy");
    }
  };

  const handleCheckout = async () => {
    // debugger;
    let checkTemp = checkOutData;
    let orderSummeryDtoData = checkTemp?.final?.map((x: any) => {
      return {
        ticketConfigId: x?.id,
        ticketType: x?.ticketType,
        qty: x?.qty,
        price: x?.price,
      };
    });

    let isValid: any = [];

    if (isEmpty(checkOutData?.detail?.firstName ?? "")) {
      isValid.push("Please Enter First Name ");
    }
    if (isEmpty(checkOutData?.detail?.lastName ?? "")) {
      isValid.push("Please Enter Last Name");
    }
    if (isEmpty(checkOutData?.detail?.phone ?? "")) {
      isValid.push("Please Enter Phone Number ");
    } else if (!isValidPhoneNumber(checkOutData?.detail?.phone?.toString())) {
      isValid.push("Invalid Phone Number");
    }
    if (isEmpty(checkOutData?.detail?.email ?? "")) {
      isValid.push("Please Enter Email");
    }

    if (isValid.length > 0) {
      return toast.error(isValid.join("\n"));
    }

    setLoading(true);
    let param = {
      customerDto: {
        firstName: checkOutData?.detail?.firstName,
        lastName: checkOutData?.detail?.lastName,
        phone: checkOutData?.detail?.phone,
        email: checkOutData?.detail?.email,
        amountDetail: {
          Total: checkOutData?.totalTicketPrices,
          ServicePrice: checkOutData?.serviceFees,
          SubTotal: checkOutData?.subTotal,
          Tax: checkOutData?.tax,
        },
      },

      orderDto: {
        ServiceFees: checkOutData?.serviceFees,
        SubTotal: checkOutData?.subTotal,
        Tax: checkOutData?.tax,
        total: checkOutData?.totalTicketPrices,
        eventId: checkOutDataEventDetail?.eventId,
        paymentTypeId: STRING.PAYMENT_TYPE_ID.CARD,
        discount: checkOutData?.couponDiscountPrice,
      },
      couponCode: state?.couponInfo?.couponCode,
      ordersItemDto: orderSummeryDtoData,
    };
    let order = await POST(APIS.CHECKOUT, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          let newData = {
            address: res?.result?.coustomerDetail?.email,
            firstName: res?.result?.coustomerDetail?.firstName,
            lastName: res?.result?.coustomerDetail?.lastName,
            phone: res?.result?.coustomerDetail?.phone,
          };
          let temp = {
            ...state?.CheckOutData,
            detail: newData,
            totalTicketPricesIncludeCouponPrice:
              res?.result?.orderDetail?.total,
          };

          return res?.result;
        } else {
          toast.error(res?.errors[0]);
          setLoading(false);
          return;
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
    return order;
  };

  const UpdateByStatus = async (orderId: any) => {
    // debugger;
    if (orderId) {
      await POST(APIS.PAYMENT_STATUS_UPDATE + "?Id=" + orderId + "&PaymentStatusId=2")
        .then((res: any) => {
          console.log("UpdateByStatus Response", res);
        })
        .catch((error) => {
          console.log("UpdateByStatus error", error);
        });
    }
  };
  
  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    let order = await handleCheckout();
    if (order?.customerDetail?.id === undefined) {
      setValidation(true);
      if (!formValidator()) return;
    } else {
      if (!elements) {
        return;
      }
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setErrorMessage(submitError?.message);
        return;
      }

      let productDto = checkOutData?.final?.map((x: any) => {
        return {
          Name: x?.ticketType,
          DefaultPrice: x?.price,
          Created: x?.createdDate,
          UnitLabel: x?.qty,
        };
      });
      setLoading(true);
      let param = {
        Products: productDto,
        Email: checkOutData?.detail?.email,
        Currency: "USD",
        Amount: checkOutData?.totalTicketPrices,
        CustomerId: order?.customerDetail?.id,
        OrderId: order?.orderDetail?.id,
        AmountDetail: {
          Total: checkOutData?.totalTicketPrices,
          ServiceFees: checkOutData?.serviceFees,
          SubTotal: checkOutData?.subTotal,
          Tax: checkOutData?.tax,
          CouponDiscountPrice: checkOutData?.couponDiscountPrice,
        },
        couponCode: state?.couponInfo?.couponCode,
        OrderNumber: order?.orderDetail?.orderNumber,
      };
      let temp = await POST(APIS.CREATE_INTENT, param).then((res: any) => {
        return res?.result?.client_secret;
      });

      let clientSecret = temp;

      if (!stripe) {
        return;
      }

      if (
        isEmpty(checkOutData?.detail?.email ?? "") ||
        isEmpty(checkOutData?.detail?.firstName ?? "") ||
        isEmpty(checkOutData?.detail?.phone ?? "")
      ) {
        return toast.error("please enter valid billing details");
      }

      await UpdateByStatus(order?.orderDetail?.id);

      await stripe
        .confirmPayment({
          elements,
          clientSecret,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                email: checkOutData?.detail?.email,
                name: checkOutData?.detail?.firstName,
                phone: checkOutData?.detail?.phone,
              },
            },
            return_url: APIS.STRIPE_SUCCESS_PAYMENT_REDIRECT_URL,
          },
        })
        .then(async (result) => {
          toast.success("Payment Successful");
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  return (
    <form onSubmit={(e) => handlePublishOnClick(e)}>
      <div>
        <PaymentElement />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Checkbox
          style={{ height: "10px", width: "10px", marginRight: "8px" }}
          {...label}
          onChange={() => setIsAgree(!isAgree)}
          value={isAgree}
        />
        <Typography sx={{ width: "80%", fontWeight: "600" }}>
          I agree to the
          <Link
            href="/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            terms{" "}
          </Link>{" "}
          and acknowledge the
          <Link
            href="/privacy-and-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            privacy policy.
          </Link>
        </Typography>
      </div>
      <Button
        size="medium"
        variant="contained"
        sx={{ boxShadow: "none" }}
        style={{ backgroundColor: Color.primary, marginTop: "10px" }}
        disabled={!stripe || loading}
        fullWidth
        type="submit"
      >
        Submit Payment
      </Button>
      <FullScreenLoader open={loading} />
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};

const stripePromise = loadStripe(stripePublishableKey);

// infinity
// const stripePromise = loadStripe("pk_test_51MWZ6YSBWmg5uFs7QYiFvqFToITsu46An6p74pptFlU1wAoVa2pXNghknyx9G8aUqdsDRLzxMe3BqswK5yVIUlGU00FzNprC32");

const options: Options = {
  mode: "payment",
  amount: 1099,
  currency: "usd",
  appearance: {},
};

const CardInput: React.FC = () => {
  const myElementRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <Elements stripe={stripePromise} options={options}>
        <div id="my-element" ref={myElementRef}>
          <CheckoutForm />
        </div>
      </Elements>
    </>
  );
};
export default CardInput;
